import { render, staticRenderFns } from "./CompactLayout.vue?vue&type=template&id=2c644520&scoped=true"
import script from "./CompactLayout.vue?vue&type=script&lang=js"
export * from "./CompactLayout.vue?vue&type=script&lang=js"
import style0 from "./CompactLayout.vue?vue&type=style&index=0&id=2c644520&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2c644520",
  null
  
)

export default component.exports